import { ProductForm } from './productForm';

import { Backend } from '.';

export enum ContentrParagraphType {
  WysiwygParagraph = 'WysiwygParagraph',
  FormParagraph = 'FormParagraph',
  // SushiBarParagraph = 'SushiBarParagraph',
}

export interface ContentrAreas {
  [areaId: string]: AnyContentrParagraph[];
}

export interface ContentrAreasResponse {
  contentr_areas: ContentrAreas;
  can_edit: boolean;
}

interface AbstractContentrParagraph<RawData = unknown, RenderedData = RawData> {
  readonly type: Readonly<ContentrParagraphType | string>;
  readonly rendered_data: Readonly<RenderedData>;

  // you get these only when logged in
  readonly id?: Readonly<number>;
  readonly global?: boolean;
  readonly has_unpublished_data?: boolean;
  readonly visible?: boolean;
  readonly visible_at?: Date;
  readonly hide_at?: Date;
  unpublished_data?: RawData;
  _destroy?: boolean;
}

interface UnknownContentrParagraph extends AbstractContentrParagraph<unknown> {
  type: string;
  // when released in TS (https://github.com/microsoft/TypeScript/pull/29317) use
  // type: string & (not ContentrParagraphType);
}

export interface WysiwygContentrParagraphConfig {
  body: string;
}

export interface WysiwygContentrParagraph extends AbstractContentrParagraph<WysiwygContentrParagraphConfig> {
  type: ContentrParagraphType;
}

export interface FormContentrParagraphConfig {
  form_id: number;
  title?: string;
  thankyou_message?: string;
  button_label?: string;
}

export interface RenderedFormContentrParagraphConfig extends FormContentrParagraphConfig {
  form: ProductForm;
}

export interface FormContentrParagraph extends AbstractContentrParagraph<FormContentrParagraphConfig> {
  type: ContentrParagraphType.FormParagraph;
}

export type AnyContentrParagraph = WysiwygContentrParagraph | FormContentrParagraph | UnknownContentrParagraph;

let pendingRequest: AbortController;

export async function requestContentrForScope(scope: string) {
  if (pendingRequest) pendingRequest.abort();
  pendingRequest = new AbortController();
  try {
    return await Backend.get<ContentrAreasResponse>(`/contentr/${scope.replace(/^\//, '')}`, {
      signal: pendingRequest.signal,
    });
  } finally {
    pendingRequest = null;
  }
}

export async function updateContentrForScope(scope: string, areas: ContentrAreas) {
  if (pendingRequest) pendingRequest.abort();
  pendingRequest = new AbortController();
  try {
    return await Backend.put<ContentrAreasResponse>(`/contentr/${scope.replace(/^\//, '')}`, {
      body: JSON.stringify({
        contentr_areas: areas,
      }),
      signal: pendingRequest.signal,
    });
  } finally {
    pendingRequest = null;
  }
}

export async function publishContentrParagraph(paragraphId: number) {
  return await Backend.put<AnyContentrParagraph>(`/contentr/publish/${encodeURIComponent(paragraphId)}`);
}
